module.exports = __webpack_public_path__ + "static/fonts/Robotothinitalic.f31f315.woff2";